import useWebTippsConfigurationTableColumns from './useWebTippsConfigurationTableColumns'

export default useWebTippsConfigurationTableColumns
